
<div class="p-2 busy-overlay-parent" [ngClass]="isLoading?'disabled':''">

    <div *ngIf="isLoading || bSyncing" class="font-weight-bold busy-overlay">
      <i class="fa fa-spinner fa-spin"></i>&nbsp;Syncing Waypoints...
    </div>

    <div *ngIf="errorMsg" class="alert alert-danger d-flex flex-row justify-content-between">
        {{errorMsg}}
        <div role="button" (click)="errorMsg=''"><i class="fa fa-times"></i></div>
    </div>

    <div *fesListView="let filteredWaypoints of rxWaypoints">
        <h5>RxDB Waypoints</h5>
        <div class="d-flex">
            <button class="btn btn-secondary btn-sm m-1 mr-auto" (click)="clearWaypoints()">Rebuild</button>
            <a href="javascript:false;" (click)="loadWaypoints()"><i class="fas fa-sync"></i>&nbsp;Refresh</a>
        </div>
        <table class="table table-striped table-bordered table-sm">
            <thead>
                <tr>
                    <th fesSortField="_id">_id</th>
                    <th fesSortField="pathId">pathId</th>
                    <th fesSortField="pointId">pointId</th>
                    <th fesSortField="fromPointId">fromPointId</th>
                    <th fesSortField="waypointOrder">waypointOrder</th>
                    <th fesSortField="segment">segment</th>
                    <th fesSortField="type">type</th>
                    <th fesSortField="updatedAt">updatedAt</th>
                    <th class = "d-none" fesSortField="_rev">_rev</th>
                    <!-- <th></th> -->
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td><input fesFilterField="_id"class="small w-100" /></td>
                    <td><input fesFilterField="pathId"class="small w-100" /></td>
                    <td><input fesFilterField="pointId"class="small w-100" /></td>
                    <td><input fesFilterField="fromPointId"class="small w-100" /></td>
                    <td><input fesFilterField="waypointOrder"class="small w-100" /></td>
                    <td><input fesFilterField="segment"class="small w-100" /></td>
                    <td><input fesFilterField="type"class="small w-100" /></td>
                    <td><input fesFilterField="updatedAt"class="small w-100" /></td>
                    <td class = "d-none"><input fesFilterField="_rev"class="small w-100" /></td>
                    <!-- <td></td> -->
                </tr>
                <tr *ngFor="let waypoint of filteredWaypoints;">
                    <td>{{waypoint._id}}</td>
                    <td>{{waypoint.pathId}}</td>
                    <td>{{waypoint.pointId}}</td>
                    <td>{{waypoint.fromPointId}}</td>
                    <td>{{waypoint.waypointOrder}}</td>
                    <td>{{waypoint.segment}}</td>
                    <td>{{waypoint.type}}</td>
                    <td>{{waypoint.updatedAt|date:'yyyy-MM-dd HH:mm:ss'}}</td>
                    <td class = "d-none">{{waypoint._rev}}</td>
                    <!-- <td class="text-center align-middle">
                        <a class="text-nowrap" href="javascript:false;" (click)="editWayPoints(waypoint)">edit</a>
                    </td> -->
                </tr>
            </tbody>
        </table>
    </div>

</div>
